import {Directive} from '@angular/core';
import {StorageDirective, StorageService} from '@core/src/public-api';
import {Router} from '@angular/router';
import {LoginService} from '@services/login.service';

@Directive({
  selector: '[siStorageExt]'
})
export class StorageExtDirective extends StorageDirective {
  userId: number;

  constructor(
    router: Router,
    storageService: StorageService,
    private loginService: LoginService
  ) {
    super(router, storageService);
  }

  getStorageName(): string {
    let storageName = super.getStorageName();
    this.userId = this.userId || this.loginService.getSessionUser()?.id;
    if (this.userId) {
      storageName += `.${this.userId}`;
    }

    return storageName;
  }
}

